/** Texto de ayuda bajo etiquetas de formulario laboral/REPSE. */
export default function FieldHint({ children }) {
  if (!children) return null;
  return (
    <p className="text-[10px] text-muted-foreground leading-snug m-0 mt-0.5">
      ({children})
    </p>
  );
}
